(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function() {
    var url = new URL(window.location.href);
    if (url.hash) {
      document.addEventListener(
        'DOMContentLoaded',
        function() {
          var card = document.getElementById(url.hash.slice(1));
          if (card) card.scrollIntoView({ behavior: 'instant' });
        },
        { once: true }
      );
    }

    var container = document.querySelector('results-list[data-collection-handle]');
    if (container) {
      var handle = container.getAttribute('data-collection-handle');
      if (handle) {
        var links = container.querySelectorAll('a[href*="/products/"]');
        links.forEach(function(a) {
          var href = a.getAttribute('href');
          if (!href || href.indexOf('/collections/') !== -1) return;
          var match = href.match(/\/products\/([^?#]+)/);
          if (!match) return;
          var productPath = match[1];
          var newHref = '/collections/' + handle + '/products/' + productPath;
          if (href.indexOf('?') !== -1) newHref += href.slice(href.indexOf('?'));
          if (href.indexOf('#') !== -1) newHref += href.slice(href.indexOf('#'));
          a.setAttribute('href', newHref);
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
